import React from 'react';
import useLangRelPathBase from './useLangRelPathBase';
import Button from '../components/button/button';
import { encryptPayload, sendUserIdToDB, testsToTrack } from '../components/a-b-testing/useButtons';
import { dmarcBrandedRegisterUrl, emailFinderBrandedRegisterUrl, registerUrl, warmupBrandedRegisterUrl } from './environments';

const LangButton = (props) => {
  const langRelPathBase = useLangRelPathBase();
  let to = props.to;
  let customAB = props.customAB;
  const latest_test = typeof window !== 'undefined' ? sessionStorage.getItem('lst') : null;
  const urlToTrack = [registerUrl, warmupBrandedRegisterUrl, dmarcBrandedRegisterUrl, emailFinderBrandedRegisterUrl];

  if (to?.startsWith('/')) {
    to = langRelPathBase + to;
  }

  const handleClick = async (event) => {
    if (!urlToTrack.includes(to) || (!latest_test && urlToTrack.includes(to))) {
      return;
    }

    const userId = localStorage.getItem('vid');
    if (!userId || customAB || !latest_test) {
      return;
    }
    event.preventDefault();

    const test = testsToTrack.find((test) => test.id === latest_test);
    const version_index = localStorage.getItem(latest_test);

    try {
      const payload = {
        events: [{ event: 'has_clicked_element', payload: true }],
        test_id: latest_test,
        user_token: userId,
        page_version: test?.versions[version_index] || null,
      };

      await sendUserIdToDB(payload);
    } catch (error) {
      console.error('Error in handleUserAction:', error);
    } finally {
      let encryptedBody = undefined;
      encryptedBody = encryptPayload({
        test_id: latest_test,
        user_token: userId,
        page_version: test?.versions[version_index] || null,
      });
      const callback = ({ param }) => {
        window.location.href = props.to + param;
      };

      // Execute callback
      callback({
        param: encryptedBody ? `?ek=${encodeURIComponent(encryptedBody.encryptedKey)}&v=${encodeURIComponent(encryptedBody.iv)}` : '',
      });
    }
  };
  const modifiedProps = { ...props, children: undefined, to, onClick: props.onClick ? props.onClick : handleClick };

  return <Button {...modifiedProps}>{props.children}</Button>;
};

export default LangButton;
